import clsx from 'clsx';
import { createPortal } from 'react-dom';
import { TooltipArrowIcon } from '../../icons';
import styles from '../Tooltip.module.css';

export function TooltipPopup({
  popupRef,
  content,
  wrap,
  bubbleMaxWidthPreset,
  showArrow,
  arrowWidthPx,
  arrowHeightPx,
  bubbleWidthPx,
  bubbleMaxWidthPx,
  left,
  top,
  arrowLeft,
  ready,
}) {
  return createPortal(
    <div
      ref={popupRef}
      className={clsx(styles.popup)}
      role="tooltip"
      style={{
        left: `${left}px`,
        top: `${top}px`,
        visibility: ready ? 'visible' : 'hidden',
        ['--arrow-left']: `${arrowLeft}px`,
        ['--arrow-w']: `${arrowWidthPx}px`,
        ['--arrow-h']: `${arrowHeightPx}px`,
        ...(bubbleWidthPx
          ? {
              ['--bubble-w']: `${bubbleWidthPx}px`,
            }
          : null),
        ...(bubbleMaxWidthPx
          ? {
              ['--bubble-max-w']: `${bubbleMaxWidthPx}px`,
            }
          : null),
      }}
    >
      <div
        className={clsx(
          styles.bubble,
          wrap === 'normal' && styles.bubbleWrap,
          bubbleMaxWidthPreset === 'md' && styles.bubbleMaxMd,
        )}
      >
        {content}
      </div>
      {showArrow ? (
        <div className={clsx(styles.arrow)} aria-hidden>
          <TooltipArrowIcon
            className={clsx(styles.arrowIcon)}
            width={arrowWidthPx}
            height={arrowHeightPx}
          />
        </div>
      ) : null}
    </div>,
    document.body,
  );
}
